import { gql } from "@apollo/client";

export const REFERENCES = gql`
  query REFERENCES {
    references {
      id
      name
      value
    }
  }
`;

export const UPDATE_CREATE_REFERENCE = gql`
  mutation UPDATE_CREATE_REFERENCE($data: UpdateCreateReferenceInput!) {
    updateCreateReference(data: $data) {
      id
      name
      value
    }
  }
`;
